<template>
  <v-form class="mb-3" autocomplete="off" @submit.prevent="">
    <v-row class="filters" align="center" justify="start">
      <v-col class="mt-0 pt-0 pr-11">
        <v-row class="mt-3">
          <v-col cols="12" sm="6" md="4" lg="3" class="pb-0">
            <v-text-field
              v-model.trim="filters.searchTerm"
              label="Hledat"
              outlined
              dense
              background-color="white"
              append-icon="mdi-magnify"
              :prepend-icon="filters.searchTerm ? 'mdi-close' : 'mdi-none'"
              @click:append="filter"
              @click:prepend.prevent="removeFromFilter('searchTerm')"
              @keydown.enter="filter()"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pb-0 filter-datepicker filter-datepicker--from"
          >
            <v-text-field
              v-model.trim="dateFromFormatted"
              outlined
              dense
              background-color="white"
              label="Platnost od"
              append-icon="mdi-calendar-arrow-left"
              :prepend-icon="dateFromFormatted ? 'mdi-close' : 'mdi-none'"
              @blur="filters.dateSince = setParsedDateSince(dateFromFormatted)"
              @click:prepend="filters.dateSince = null"
              @click:append="menuForDateFrom = true"
            />

            <v-menu
              ref="menuForDateFrom"
              v-model="menuForDateFrom"
              attach=".filter-datepicker--from"
              :close-on-content-click="false"
              transition="scale-transition"
              max-width="290px"
              min-width="290px"
            >
              <v-date-picker
                v-model="filters.dateSince"
                :first-day-of-week="1"
                no-title
                @input="menuForDateFrom = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pr-11 pb-6 text-right">
        <v-btn depressed height="40px" min-width="130px" outlined @click="resetFilter">
          Zrušit filtr
        </v-btn>

        <v-btn
          depressed
          height="40px"
          min-width="130px"
          color="primary"
          class="ml-4"
          @click="filter"
        >
          Filtrovat
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import parseDate from '@/utils/parseDate'

export default {
  name: 'ProductPricesFilters',
  data() {
    return {
      dateFromFormatted: null,
      menuForDateFrom: false,
      filters: {
        searchTerm: null,
        dateSince: null,
      },
    }
  },
  computed: {
    filtersFilled() {
      let state = false
      Object.keys(this.filters).forEach((filter) => {
        if (filter !== 'searchTerm') {
          if (this.filters[filter]) {
            state = true
            return true
          }
        }
        return state
      })
      return state
    },
    maxForDateFrom() {
      if (this.filters.dateUntil) {
        return new Date(this.filters.dateUntil).toISOString()
      }
      return new Date().toISOString()
    },
  },
  watch: {
    'filters.dateSince': {
      handler() {
        this.dateFromFormatted = this.formatDate(this.filters.dateSince)
      },
    },
  },
  async created() {
    const ref = this
    // eslint-disable-next-line no-unused-vars
    this.$eventBus.$on('productResetFilter', function (value) {
      ref.resetFilter()
    })
    this.setFilter()
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    setParsedDateSince(dateFormatted) {
      this.filters.dateSince = parseDate(dateFormatted)
      return this.filters.dateSince
    },
    filter() {
      const filters = {
        ...this.filters,
      }
      this.$emit('filter', filters)
    },
    removeFromFilter(removingFilter) {
      this.filters[removingFilter] = null
      this.filter()
    },
    resetFilter() {
      Object.keys(this.filters).forEach((filter) => {
        this.filters[filter] = null
      })
      this.$emit('filter', this.filters)
    },
    setFilter() {
      if (Object.values(this.$route.query)) {
        Object.entries(this.$route.query).forEach((keyValue) => {
          const [key, value] = keyValue
          if (key !== 'searchTerm') {
            this.filters[key] = Number(value) || value
          } else {
            this.filters[key] = value
          }
        })
      }
    },
  },
}
</script>
